import { render, staticRenderFns } from "./highend.vue?vue&type=template&id=3484eb44&scoped=true&"
import script from "./highend.vue?vue&type=script&lang=js&"
export * from "./highend.vue?vue&type=script&lang=js&"
import style0 from "./highend.vue?vue&type=style&index=0&id=3484eb44&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3484eb44",
  null
  
)

export default component.exports